module.exports = __webpack_public_path__ + "static/media/Passed.fcf972a6.svg";